import React from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import { Button, Header } from 'semantic-ui-react'
export default function StoreMap(props) {


    const { stores = false, range, mapView, selected, isbn="", location } = props;


    // [TODO] toggle the zoom level of the map based on the radius
    const getZoom = (_r) => {
        switch (_r) {
            case 25:
                return 13;
            case 50:
                return 12;
            case 100:
                return 11;
            case 300:
                return 10;
            default:
                return 13;
        }
    }

    const onhandLabel = "In stock";
    const onorderLabel = "On order";
    const unknownLabel = "";
    const preorderLabel = "Pre-order";

    const drawStatus = (_item) => {

        let { url, onhand = null, onorder = null, is_preorder = null } = _item;
        // Pre-Order
        if (is_preorder) {
            return (<span style={{ "color": "orange", "padding": "1px 0px" }}><small>{preorderLabel}</small></span>)
        }
        // In stock
        if (onhand) {
            return (<span style={{ "color": "#419f4a",  "padding": "1px 0px" }}><small>{onhandLabel}</small></span>)
        }
        // On Order
        if (!onhand && onorder) {
            return (<span style={{ "color": "orange", "padding": "1px 0px" }}><small>{onorderLabel}</small></span>)
        }
        // No inventory
        if (!onhand && !onorder && isbn && url !== "") {
            return (<></>)
        }
        return (<>{unknownLabel}</>)
    }

    // Link to website in new tab
    const visitSite = (_url) => {
        window.open(_url, "_blank");
    }

    // Draw the markers
    const drawMarkers = () => {
        return stores.rows.map((_item, index) => {
            return (
                <Marker key={index} position={[_item.latitude, _item.longitude]}>
                    <Popup >
                    <div style={{ "padding": "3px", "minWidth" : "250px" }}>
                        <Header size="tiny" as='h2'>
                            <div style={{ "maxWidth": "280px" }}>
                                <span>{_item.name} -<span style={{ color: "#49af14" }}> {_item.distance_km}km</span></span>
                            </div>
                            <div style={{ "display": "block", "fontWeight": "normal" }}>
                                {drawStatus(_item)}
                            </div>
                            <div className="shim" />
                            <Header.Subheader>
                                {_item.address}
                            </Header.Subheader>
                            <div className="shim" />
                            <Header.Subheader>
                                {_item.city}, {_item.province}
                            </Header.Subheader>
                            <Header.Subheader>
                                <div className="shim" />
                                <strong><a href={"tel:" + _item.phone}>{_item.phone} &nbsp;</a></strong>
                                <div style={{ "float": "right" }}>
                                    <Button onClick={() => visitSite(_item.url)} style={{ "padding": "4px 10px", "textAlign": "right", "marginTop": "auto" }} primary size="mini" content='Visit' />
                                </div>
                            </Header.Subheader>
                        </Header>
                    </div>
                    </Popup>
                </Marker>
            )
        })
    }

    // Check for mobile device
    const mobileAndTabletCheck = () =>  {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      }

    // Context so we can run methods on the map (move, zoom etc) - default location is bookmanager kelowna
    function MyContext() {
        const map = useMap();
        map.panTo([(selected) ? selected.latitude : location.latitude, (selected) ? selected.longitude : location.longitude]);
        return drawMarkers()
    }

    // Hide the map on mobile screen if not specifically set to mobile view
    if(mobileAndTabletCheck() && !mapView){
        return(<></>)
    }


    if(!location.latitude && !selected){
        return (<></>);
    }

    //  Default location is bookmanager kelowna
    return (
            <MapContainer scrollWheelZoom={true} style={{ "height": "100vh" }}
                center={[(selected) ? selected.latitude : location.latitude, (selected) ? selected.longitude : location.longitude]}
                tap={false}
                zoom={getZoom(range)}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                />
                <MyContext />
            </MapContainer>

    )
}